import { useAvivaDispatch } from "@redux/hook"
import { updateToDefaultStateStep1 } from "@redux/slices/SHIELD_STARTER/step1Slice"
import { updateToDefaultStateStep2 } from "@redux/slices/SHIELD_STARTER/step2Slice"
import { updateToDefaultStateStep3 } from "@redux/slices/SHIELD_STARTER/step3Slice"
import { updateToDefaultStateStep4 } from "@redux/slices/SHIELD_STARTER/step4Slice"
import { updateToDefaultStateStep5 } from "@redux/slices/SHIELD_STARTER/step5Slice"

export default function useReduxReset() {
    const dispatch = useAvivaDispatch()

    return (reststep = "ALL")=>{
        switch(reststep){
            case 'ALL':{
                dispatch(updateToDefaultStateStep1(""))
                dispatch(updateToDefaultStateStep2(""))
                dispatch(updateToDefaultStateStep3(""))
                dispatch(updateToDefaultStateStep4(""))
                dispatch(updateToDefaultStateStep5(""))
                break;
            }
            case 'STEP1':{
                dispatch(updateToDefaultStateStep1(""))
                break;
            } 
            case 'STEP2':{
                dispatch(updateToDefaultStateStep2(""))
                break;
            }
            case 'STEP3':{
                dispatch(updateToDefaultStateStep3(""))
                break;
            }
            case 'STEP4':{
                dispatch(updateToDefaultStateStep4(""))
                break;
            }
            case 'STEP5':{}
                dispatch(updateToDefaultStateStep5(""))
                break;
            }
        }

    }